<template lang="pug">
  div
    div
      div.d-flex.align-items-center.mb-2
        input#is_none_selected.form-check-input(type='checkbox', v-model="is_none_selected", @change="resetSelections" value="1" :disabled="!is_visitor_type_selected && !is_source_param_selected")
        label.form-check-label(for='is_none_selected').ml-2 指定なし
      div.d-flex.align-items-center.mb-2
        input#is_visitor_type_selected.form-check-input(type='checkbox', v-model="is_visitor_type_selected", @change="clearNoneSelected" value="1")
        label.form-check-label(for='is_visitor_type_selected').ml-2 新規 / リピート指定
      div#target-source-container(v-if="is_visitor_type_selected")
        div.form-check.mb-1
          input#new_visitor.form-check-input(type='radio', v-model='visitor_type', value='new')
          label.form-check-label(for='new_visitor') 新規訪問者に表示する
        div.form-check.mb-1
          input#repeat_visitor.form-check-input(type='radio', v-model='visitor_type', value='repeat')
          label.form-check-label(for='repeat_visitor') リピート訪問者に表示する
      div.d-flex.align-items-center.mb-2
        input#is_source_param_selected.form-check-input(type='checkbox', v-model="is_source_param_selected", @change="clearNoneSelected" value="1")
        label.form-check-label(for='is_source_param_selected').ml-2 流入元 / パラメータ指定
      div#target-source-container(v-if="is_source_param_selected")
        div.target-source-item(v-for="(from, index) in local_froms" :key="index")
          div.d-flex(v-if="index !== 0")
            p(v-if="from.operator === 'and'") and
            p(v-else-if="from.operator === 'or'") or
          div.d-flex.align-items-center.mb-2
            select.form-control.mr-2(v-model="from.condition_type")
              option(value='url_param') URLパラメータ
              option(value='exit_page') リファラーURL
            input.form-control.mr-2(type='text', v-model="from.value", placeholder="条件を入力")
            select.form-control(v-model="from.action_type")
              option(value='show') 表示する
              option(value='hide') 表示しない
            button.btn.btn-link(v-if="index > 0" @click="removeCondition(index)") &times;

        div.mt-2(v-if="local_froms.length < 2")
          button.btn.btn-outline-primary.mr-2(@click="addCondition('and')") +and
          button.btn.btn-outline-secondary(@click="addCondition('or')") +or
</template>

<script>
export default {
  props: {
    isNoneSelected: {
      type: Number,
      default: 1
    },
    isNewVisitor: {
      type: Number,
      default: 0
    },
    isRepeatVisitor: {
      type: Number,
      default: 0
    },
    froms: {
      type: Array,
      default: () => [
        { condition_type: 'url_param', value: '', action_type: 'show', operator: 'and' }
      ]
    }
  },
  data() {
    return {
      is_none_selected: this.isNoneSelected,
      is_visitor_type_selected: Boolean(this.isNewVisitor) || Boolean(this.isRepeatVisitor),
      is_source_param_selected: this.froms.length > 0,
      visitor_type: Boolean(this.isNewVisitor) ? 'new' : (Boolean(this.isRepeatVisitor) ? 'repeat' : ''),
      local_is_new_visitor: this.isNewVisitor,
      local_is_repeat_visitor: this.isRepeatVisitor,
      local_froms: this.froms.length > 0 ? [...this.froms] : [{ condition_type: 'url_param', value: '', action_type: 'show', operator: 'and' }]
    }
  },
  methods: {
    addCondition(operator) {
      this.local_froms.push({
        condition_type: 'url_param',
        value: '',
        action_type: 'show',
        operator: operator
      });
    },
    removeCondition(index) {
      this.local_froms.splice(index, 1);
    },
    resetSelections() {
      if (this.is_none_selected) {
        // フラグおよびフォームデータをリセット
        this.is_visitor_type_selected = false;
        this.is_source_param_selected = false;
        this.visitor_type = '';
        this.local_is_new_visitor = 0;
        this.local_is_repeat_visitor = 0;
        this.local_froms = [
          { condition_type: 'url_param', value: '', action_type: 'show', operator: 'and' }
        ];

        this.emitChanges();
      }
    },
    clearNoneSelected() {
      if (this.is_visitor_type_selected || this.is_source_param_selected) {
        this.is_none_selected = 0;
      }

      if(! this.is_visitor_type_selected) {
        this.local_is_new_visitor = 0;
        this.local_is_repeat_visitor = 0;
      }

      if(! this.is_source_param_selected) {
        this.local_froms = [{ condition_type: 'url_param', value: '', action_type: 'show', operator: 'and' }]
      }
    },
    emitChanges() {
      this.$emit('updateData', {
        is_none_selected: this.is_none_selected,
        is_new_visitor: this.local_is_new_visitor,
        is_repeat_visitor: this.local_is_repeat_visitor,
        froms: this.local_froms
      });
    }
  },
  watch: {
    is_visitor_type_selected(newValue) {
      if (!newValue && !this.is_source_param_selected) {
        this.is_none_selected = 1;
      }
    },
    is_source_param_selected(newValue) {
      if (!newValue && !this.is_visitor_type_selected) {
        this.is_none_selected = 1;
      }
    },
    visitor_type(newValue) {
      this.local_is_new_visitor = newValue === 'new' ? 1 : 0;
      this.local_is_repeat_visitor = newValue === 'repeat' ? 1 : 0;
      this.emitChanges();
    },
    is_none_selected() {
      this.emitChanges();
    },
    local_is_new_visitor() {
      this.emitChanges();
    },
    local_is_repeat_visitor() {
      this.emitChanges();
    },
    local_froms: {
      handler() {
        this.emitChanges();
      },
      deep: true
    }
  }
}
</script>

<style lang="scss" scoped>
</style>
